import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

const Ehbook = () => {
  const navigate = useNavigate();
  return (
    <>
      <div
        style={{
          width: "100%",
          background:
            "linear-gradient(-58deg,#8536da,rgba(134,54,218,.8549019607843137)),linear-gradient(#fff,#fff)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            padding: 1,
            justifyContent: "space-between",
            alignItems: "center",
            background: "#3d3b6f",
          }}
        >
          <Box onClick={() => navigate(-1)} style={{ textDecoration: "none" }}>
            <ChevronLeftIcon
              fontSize="medium"
              style={{
                // width: "60px",
                color: "#fff",
                border: "1px solid #f2f3f5",
                borderRadius: 50,
              }}
            />
          </Box>
          <Typography variant="subtitle2" color="#fff">
            Employee Handbook
          </Typography>
          <Box> </Box>
        </Box>
        {/* <Box
          style={{
            height: "8vh",
            position: "fixed",
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            background:
              "#3d3b6f",

            alignItems: "center",
            padding: "0 14px",
            borderBottom: "0.7px solid #ff9a8e",
          }}
        >
          <Box onClick={() => navigate(-1)} style={{ textDecoration: "none" }}>
            <ChevronLeftIcon
              fontSize="medium"
              style={{
                // width: "60px",
                color: "#fff",
                border: "1px solid #f2f3f5",
                borderRadius: 50,
              }}
            />
          </Box>
          <Typography
            variant="body2"
            color="#fff"
            style={{ marginLeft: "-50px" }}
          >
            Employee Handbook
          </Typography>
          <Box></Box>
        </Box> */}
        <img
          // style={{ marginTop: "10px" }}
          src="/images/Emp.jpg"
          width="100%"
          // height="50%"
          alt="img"
        />
   
      </div>
     

      {/* <FooterNav /> */}
    </>
  );
};
export default Ehbook;
